
export default function generateId(prefix = ''): string {
    const id = `${prefix ? prefix + '-' : ''}${Math.random().toString(36).slice(2)}`;
    return id;
}
